
import { Route, Routes } from 'react-router-dom'
import Main_page from './Pages/Main_page'
import Article_page from './Pages/Article_page';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route  path='/' element={<Main_page/>} />
        <Route  path='/article' element={<Article_page/>} />
      </Routes>
    </div>
  );
}

export default App;
